// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__32eph","description":"PatientConsentPreview_description__3FC3W"};